//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "account-menu",
  data() {
    return {
      content: {},
      activePage: null,
    }
  },
  async mounted() {
    this.content = (await this.$axios.get(`/contents/account-menu`)).data.details
    this.activePage = this.content?.menu_items?.indexOf(this.content?.menu_items?.find(item => item.link.fieldValue.value === location.pathname)) | 0
  },
  methods: {
    checkIfCurrentLink(link) {
      return this.$route.path === link
    }
  }
}
